export enum EMoveMode {
    cell = "cell",
    insideCell = "insideCell",
    componentCell = "componentCell",
    grid = "grid"
}